var fails = require('../internals/fails');

module.exports = !fails(function () {
  // eslint-disable-next-line es-x/no-object-isextensible, es-x/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/freezing.js
// module id = 1083
// module chunks = 0